import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import StoreEditor from './StoreEditor';
import classNames from 'classnames';
import Modules from './Modules';

const css = oxygenCss({
  root: {
    transition: 'all 0.25s ease',
    position: 'relative',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'row',
    '@phone': {
      flexDirection: 'initial'
    },
    '&banner': {
      width: '100%'
    },
    wrapper: {
      flexGrow: 1,
      flexShrink: 0,
      flexBasis: '100%',
      '@phone': {
        flexBasis: '100%'
      },
      '&size2': {
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: '50%',
        '@phone': {
          flexBasis: 'auto'
        }
      },
      '&size3': {
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: '33%',
        '@phone': {
          flexBasis: 'auto'
        }
      },
      '&size4': {
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: '25%',
        '@phone': {
          flexBasis: 'auto'
        }
      },
      '&size5': {
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: '20%',
        '@phone': {
          flexBasis: 'auto'
        }
      }
    },
    '&default': {
      width: 960,
      '@phone': {
        width: 'auto'
      }
    }
  }
});

class StoreSection extends Component {
  static propTypes = {
    type: PropTypes.oneOf(['banner', 'default']),
    selectedModule: PropTypes.object,
    modules: PropTypes.array,
    mode: PropTypes.string
  };

  static defaultProps = {
    type: 'default',
    modules: []
  };

  selectModule = (module, event) => {
    StoreOverviewActions.selectModule(module.id);
  };

  render() {
    const { type, modules, selectedModule, mode, ...other } = this.props;
    const classes = classNames(css.root, css[type]);
    const size = modules.length > 1 ? modules.length : null;
    return (
      <div className={classes}>
        {modules.map(module => {
          const { type: moduleType, ...moduleProps } = module;
          const wrapperClass = classNames(css.wrapper, {
            [css[`size${size}`]]: size
          });
          if (Modules[moduleType]) {
            const SpecializedModule = Modules[moduleType];
            return (
              <div className={wrapperClass} key={module.id}>
                <StoreEditor
                  selected={selectedModule && selectedModule.id === module.id}
                  onTouchTap={this.selectModule.bind(this, module)}
                  mark={mode === 'editor'}
                >
                  <SpecializedModule {...other} {...moduleProps} />
                </StoreEditor>
              </div>
            );
          }
          return null;
        })}
      </div>
    );
  }
}

export default StoreSection;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreSection.js